import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { login_tableApi } from "../../app/slices/login_tableSlice";
import { LinearProgress } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI


export default function LoginTable() {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(login_tableApi());
  // }, [dispatch]);

  const sliceResponse = useSelector(
    (state) => state.login_table.login_table.data
  );
  const stateLoading = useSelector(
    (state) => state.login_table.loading
  );
  


  // Memoize API dispatch to avoid re-fetching
  const fetchData = useCallback(() => {
    if (!sliceResponse) {
      dispatch(login_tableApi());
    }
  }, [dispatch, sliceResponse]);

  // Use useEffect to only call API if data is not in the store
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
          header: "ID",
          size: 30,
          Cell: ({ cell }) => {
            const handleCopy = () => {
              navigator.clipboard.writeText(cell.row?.original?._id);
              toast.success("Copied to clipboard!");
            };
    
            return (
              <Tooltip title={cell.row?.original?._id}>
                <IconButton onClick={handleCopy}>
                  <ContentCopy />
                </IconButton>
              </Tooltip>
            );
          },
        }),
    columnHelper.accessor("UserRefNo", {
      header: "User Reference No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.UserRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.UserRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.UserRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("username", {
      header: "Username",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.username}</div>
      ),
    }),

    columnHelper.accessor("email", {
      header: "Email",
      size: 30,
    }),
    columnHelper.accessor("password", {
      header: "Password",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.password);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.password}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("fcm_token", {
      header: "FCM Token",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.fcm_token);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.fcm_token || "Not Available"}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("type", {
      header: "Type",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.type}</div>
      ),
    }),
    columnHelper.accessor("is_deleted", {
      header: "Is Deleted",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.is_deleted}
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),
  ];

  return (
    <>
     {/*  */}
      {/* {sliceResponse ? ( */}
        <CustomTable columns={columns} data={sliceResponse}   loading={stateLoading} permissionKey="LoginTables"/>
      {/* ) : (
        <LinearProgress />
      )} */}
    </>
  );
}
